if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

    constructor() {
      super();

      this.slides = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index = 0;
      this.length = this.slides.length;

      this.showSlide(0);

      if ( this.nextButton ) {
        this.nextButton.addEventListener('click', () => this.changeSlide('next'));
      }
      if ( this.prevButton ) {
        this.prevButton.addEventListener('click', () => this.changeSlide('prev'));
      }
    }

    showSlide(i) {
      this.slides.forEach((slide, idx) => {
        slide.style.display = idx === i ? 'flex' : 'none';
      });

      this.prevButton && this.prevButton.classList.toggle('announcement-bar__content-nav--disabled', i === 0);
      this.nextButton && this.nextButton.classList.toggle('announcement-bar__content-nav--disabled', i === this.length - 1);
    }

    changeSlide(direction) {
      if ( direction === 'next' && this.index < this.length - 1 ) this.index++;
      if ( direction === 'prev' && this.index > 0 ) this.index--;
      this.showSlide(this.index);
    }
  }

  if ( typeof customElements.get('announcement-bar') == 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
  }
}